export default __webpack_public_path__ + "static/media/colourful.ef66e877.jpg";